module.exports = __webpack_public_path__ + "c2a25ca12585d232b5962cb7c394ef85.svg";